import { WebSocketHelper } from 'classes/helpers/web-socket.helper';
import { ContextName, WsMsgType } from 'lib_ts/enums/machine-msg.enum';
import { IContextMsg } from 'lib_ts/interfaces/machine-msg/i-data-contexts';
import { useEffect } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import { useVideosStore } from 'stores/use-videos-store';

const useVideosListener = () => {
  const auth = useAuthStore((s) => s.current.auth);
  const session = useAuthStore((s) => s.current.session);
  const wsConnected = useAuthStore((s) => s.wsConnected);

  // try to load videos when authentication is successful
  useEffect(() => {
    if (!auth || !session) {
      // not allowed
      return;
    }

    useVideosStore.getState().refresh();
  }, [auth, session]);

  // i.e. server is telling the user to refresh the videos
  useEffect(() => {
    if (!wsConnected || !auth || !session) {
      // not ready and/or not allowed
      return;
    }

    const callback = (event: CustomEvent) => {
      const data: IContextMsg = event.detail;

      if (data.context === ContextName.Videos) {
        useVideosStore.getState().refresh();
      }
    };

    WebSocketHelper.on(WsMsgType.S2U_Context, callback);

    return () => {
      WebSocketHelper.remove(WsMsgType.S2U_Context, callback);
    };
  }, [wsConnected, auth, session]);
};

export default useVideosListener;
